import { render } from "./SymbolTabs.vue?vue&type=template&id=9fde90c4&scoped=true"
import script from "./SymbolTabs.vue?vue&type=script&lang=js"
export * from "./SymbolTabs.vue?vue&type=script&lang=js"

import "./SymbolTabs.vue?vue&type=style&index=0&id=9fde90c4&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fde90c4"]])

export default __exports__